import { connect } from "react-redux";
import {
  fetchCommercialUserProfileById,
  resetCommercialUserDetails,
} from "../state/action";
import {  useEffect } from "react";
import PreviewCommercialUserDetails from "./components/PreviewCommercialUserdetails";
import { useLocation, useParams } from "react-router-dom";
import { CommercialUserProps } from "../state/actionType";

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps 
const PreviewCommercialProfile: React.FC<Props> = ({
  onFetchCommercialProfile,
  fetchUserProfile,
  onResetCommercialData,
}) => {
 const { userId } = useParams<{ userId: string }>();
  const location = useLocation();
 const userData = location.state?.commercialUserData as CommercialUserProps;
  useEffect(() => {
    onFetchCommercialProfile(userId ?? "");
    onResetCommercialData();
  }, [onResetCommercialData, onFetchCommercialProfile]);
  const commercialUserProfile = fetchUserProfile?.commercialUserProfile;
  return (
    <div className="p-8 h-full overflow-hidden">
      <h2 className="text-2xl font-bold mb-2">Commercial User Deatils</h2>
      <div className="border my-6 " />
       <div className="overflow-auto max-h-[74vh] scrollbar-hide">
      <PreviewCommercialUserDetails user={userData} profile={commercialUserProfile} />
     </div>
    </div>
  );
};
const mapStateToProps = (state: any) => {
  return {
    fetchUserProfile: state.commercialUser.commercialUserProfileState,
    fetchUser: state.commercialUser.commercialUser,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  onFetchCommercialProfile: (user_id: string) =>
    dispatch(fetchCommercialUserProfileById(user_id)),
  onResetCommercialData: () => dispatch(resetCommercialUserDetails()),
});

export default connect(mapStateToProps, mapDispatchToProps)(PreviewCommercialProfile);
